import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

const baseUrl = '/api/v1/authentication';

const backchannelLogout = async (axiosInstance: AxiosInstance) => {
  const response = await axiosInstance.post(`${baseUrl}/backchannelLogout`);
  return response.data;
};

export const useBackchannelLogoutMutation = () => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useMutation({
    mutationKey: ['backchannelLogoutQuery'],
    mutationFn: () => backchannelLogout(authenticatedInstance),
  });
};
